import { DataProxy } from 'apollo-cache'
import produce, { Draft } from 'immer'
import { merge } from 'lodash'

import {
  GetTrashDocument,
  GetTrashQuery,
  GetTrashQueryVariables,
} from 'gqlTypes'

import { ErrorHandler } from 'modules/tracing'

const BASE_VARIABLES = {
  after: null,
  search: {
    name: '',
  },
}

interface ReadTrashCache {
  cache: DataProxy
  variables: GetTrashQueryVariables
}

export const readTrashCache = ({
  cache,
  variables,
}: ReadTrashCache): GetTrashQuery | null => {
  let existingData: GetTrashQuery | null
  const mergedVariables = merge(variables, BASE_VARIABLES)

  try {
    existingData = cache.readQuery<GetTrashQuery, GetTrashQueryVariables>({
      query: GetTrashDocument,
      variables: mergedVariables,
    })
  } catch (e) {
    ErrorHandler.ignore(e)
    existingData = null
  }

  return existingData
}

interface UpdateTrashCache {
  cache: DataProxy
  update: (data: Draft<GetTrashQuery['workspaceTrash']>) => void
  variables: GetTrashQueryVariables
}

export const updateTrashCache = ({
  cache,
  update,
  variables,
}: UpdateTrashCache) => {
  const mergedVariables = merge(variables, BASE_VARIABLES)

  const existingData = readTrashCache({
    cache,
    variables: mergedVariables,
  })

  if (!existingData) return

  const updated = produce(existingData, draft => {
    update(draft.workspaceTrash)
  })

  cache.writeQuery<GetTrashQuery, GetTrashQueryVariables>({
    query: GetTrashDocument,
    data: updated,
    variables: mergedVariables,
  })
}
